import {app} from '../../app';

app.component('spConfirm', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./sp-confirm.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-confirm/sp-confirm.component.js